module.exports = __webpack_public_path__ + "static/media/pic_qjwl@2x.2c135fcf.png";